import { defineMessages } from 'react-intl';

export const messages: {
	selectedIssuesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandButtonLabelText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseButtonLabelText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectAllCheckboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	selectedIssuesLabel: {
		id: 'issue-selector.selected-issues-label',
		defaultMessage: '{selectedIssueCount, select, 0 {} other {({selectedIssueCount} selected)}}',
		description:
			'Label text displayed next to or within the issue selector header showing the count of selected issues in the AI conversation action interface. Shown as text in the header area. The ICU MessageFormat select statement resolves to an empty string when selectedIssueCount is 0 (no issues selected), or to "({selectedIssueCount} selected)" when selectedIssueCount is greater than 0. The selectedIssueCount placeholder will be substituted with the number of selected issues (e.g., "(3 selected)"). The purpose is to provide users with a clear indication of how many issues they have currently selected in the selector.',
	},
	expandButtonLabelText: {
		id: 'issue-selector.expand-button-label-text',
		defaultMessage: 'Expand list',
		description:
			'Button label displayed on a button in the issue selector header that expands the collapsed issue list to show all available issues in the AI conversation action interface. Shown as the text on a button. When clicked, it expands the issue list to reveal all selectable issues. The purpose is to allow users to view the full list of issues when it has been collapsed to save screen space.',
	},
	collapseButtonLabelText: {
		id: 'issue-selector.collapse-button-label-text',
		defaultMessage: 'Collapse list',
		description:
			'Button label displayed on a button in the issue selector header that collapses the expanded issue list to hide it in the AI conversation action interface. Shown as the text on a button. When clicked, it collapses the issue list to show only the header with selected count. The purpose is to allow users to minimize the issue list to save screen space and reduce visual clutter.',
	},
	selectAllCheckboxLabel: {
		id: 'issue-selector.select-all-checkbox-label',
		defaultMessage: 'Select all',
		description:
			'Accessibility label (aria-label) and visible label for a checkbox in the issue selector header that allows users to select or deselect all issues at once in the AI conversation action interface. Shown as the label text next to a checkbox. When checked, it selects all available issues in the list; when unchecked, it deselects all issues. The purpose is to provide users with a quick way to select or deselect all issues without having to click each one individually, and to make this functionality accessible to users with assistive technologies.',
	},
});
